import styles from "./EIEComingSoon.module.css";
import { eie, about } from "../../data/about";

export default function EIEComingSoon() {
  return (
    <section id="eie" className={styles.section}>
      <div className={styles.wrapper}>
        <span className={styles.badge}>
          <span className={styles.dot} />
          EIE Excellence in Education
        </span>

        <h1 className={styles.title}>Coming soon</h1>
        <p className={styles.subtitle}>
          This page is getting a fresh new look. In the meantime, feel free
          to reach out directly &mdash; we&apos;d love to hear from you.
        </p>

        <div className={styles.contactCard}>
          <p className={styles.contactLabel}>Contact EIE</p>
          <div className={styles.contactRow}>
            <a href={`tel:${eie.contact.phone}`} className={styles.contactLink}>
              {eie.contact.phone}
            </a>
            <a href={`mailto:${about.email}`} className={styles.contactLink}>
              {about.email}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
